import { doc, getDoc, setDoc, collection, getDocs, query, where } from 'firebase/firestore'
import { db } from '@/firebase'

export async function createOrGetUser(authUser) {
  const userRef = doc(db, 'users', authUser.email)
  const userDoc = await getDoc(userRef)
  
  if (!userDoc.exists()) {
    // Create new user with default role
    const userData = {
      email: authUser.email,
      name: authUser.displayName || authUser.email,
      role: 'user',
      createdAt: new Date()
    }
    await setDoc(userRef, userData)
    return userData
  }
  
  return userDoc.data()
}

export async function getUserRole(email) {
  const userRef = doc(db, 'users', email)
  const userDoc = await getDoc(userRef)
  return userDoc.exists() ? userDoc.data().role : 'user'
}

export async function getAdminUsers() {
  const usersRef = collection(db, 'users')
  const q = query(usersRef, where('role', '==', 'admin'))
  const querySnapshot = await getDocs(q)
  return querySnapshot.docs.map(doc => ({
    email: doc.id,
    ...doc.data()
  }))
}